import { motion } from "framer-motion";
import { Linkedin } from "lucide-react";
import { fadeUp, viewport } from "@/lib/motion";

const Team = () => {
  return (
    <section id="team" className="relative py-28 lg:py-36 border-t border-black/5">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport}>
          <span className="badge-pill">
            <span className="h-1.5 w-1.5 rounded-full bg-[#43B0CE]" />
            Team
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight max-w-4xl leading-[1.1]">
            The people behind <span className="text-[#43B0CE]">AidaNova.</span>
          </h2>
        </motion.div>

        {/* TODO(content): Zoalfekar's bio needs to be rewritten to focus
            on AI/software engineering + current PhD research instead of full
            career history. Awaiting final text from the team. */}

        <div className="mt-12 grid lg:grid-cols-12 gap-8 items-start rounded-3xl border border-black/8 bg-white p-8 lg:p-10">
          <div className="lg:col-span-3 flex flex-col items-start">
            <div className="relative rounded-2xl overflow-hidden border border-black/8 w-[160px] h-[160px]">
              <img
                src="/dalida.jpg"
                alt="Dalida Alley"
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="mt-5 font-display text-xl font-bold text-[#0B2429]">Dalida Alley</h3>
            <p className="mt-1 text-sm text-[#43B0CE] font-medium">Executive Partner — AI &amp; Transformation</p>
            <a
              data-testid="leadership-linkedin"
              href="https://www.linkedin.com/in/dalida-alley-999ab929/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 rounded-full border border-black/10 px-4 py-2 text-xs font-medium text-[#3C5156] hover:border-[#43B0CE]/50 hover:text-[#43B0CE] transition-all"
            >
              <Linkedin className="h-3.5 w-3.5" /> Connect on LinkedIn
            </a>
          </div>

          <div className="lg:col-span-9">
            <p className="font-quote text-xl sm:text-2xl leading-snug text-[#0B2429]">
              "Transformation isn't a project. It's a mindset — rooted in purpose, powered by people, and delivered through bold execution."
            </p>
            <div className="mt-6 space-y-4 text-[15px] leading-relaxed text-[#3C5156]">
              <p>
                Dalida is a transformation executive with 20+ years leading strategy, innovation and digital
                change across Fortune 500 companies, public-sector entities and global consulting firms. Now based
                in the UAE, she helps organizations turn AI from a headline into measurable outcomes — aligning
                operations, technology and talent behind the decisions that actually move the business.
              </p>
              <p>
                Her approach to AI transformation is unapologetically people-first: she builds high-performing
                teams, drives cultural alignment, and embeds intelligent ways of working at scale — so AI adoption
                sticks and delivers real performance, not shelfware. With a career spanning the U.S. and the Middle
                East, she brings a global perspective and a bias for grounded, honest execution. It's the same
                belief that shapes AidaNova: AI should work in service of people, not the other way around.
              </p>
            </div>
            <div className="mt-6 flex flex-wrap gap-2">
              {["AI Transformation Strategy", "Enterprise Change", "Operating Model Design", "People-First Leadership", "Global Delivery"].map((t) => (
                <span key={t} className="rounded-full border border-black/10 bg-[#EDF8F8] px-3 py-1.5 text-xs text-[#3C5156]">{t}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
